import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import ReportTimeReports_Settings from "./settings";
import {loadHourlyCost} from "../../../../hour-cost/init";
import {loadTimeReportData} from "../../../../../../analytics/efforts/time-reports-common/load-data";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTimeReports extends Report<ReportTimeReports_Settings> {

    public defaultTableSettings?    : any
    public disableUsersFilter       : boolean = false

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TIME_REPORTS
        super(data);

        this.icon         = "isvg-time-by-project"
        this.description  = "Displays reported hours for a specific project within a selected period, providing a clear record of logged time and overall effort."

        this.settings     = new ReportTimeReports_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportTimeReports {
        return new ReportTimeReports(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTimeReports_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }

    async loadData():Promise<any> {

        await loadHourlyCost()

        const data : any[] = await loadTimeReportData(
            this.settings.daterange.start,
            this.settings.daterange.end,
            this.settings.timeReportType,
            this.settings.taskTypeIds
        )

        return data
    }
}
